import React, {
  createContext,
  useContext,
} from "react";
import { useImageStore } from "./store";

const StorageContext = createContext();

export const StorageProvider = ({ children }) => {
  const { images, addImage, setCaptures } = useImageStore();

  // Image Store
  const __addImage = ({ view, url, alias }) => {
    addImage({ view, url, alias });
  };

  const __setImage = (captures) => {
    setCaptures(captures);
  };

  const __capturesAsArray = () => {
    return images.length ? images.map(([, value]) => value.url) : [];
  };

  const __getCaptures = () => {
    // JSON.parse(data).map(() => new Map(JSON.parse(data)))

    // return images.length
    //   ? images.map((value) => new Map(value))
    //   : [];
    return images;
  };

  const providers = {
    images,
    __addImage,
    __setImage,
    __capturesAsArray,
    __getCaptures,
    // dataBeaver
  };

  return (
    <StorageContext.Provider value={providers}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorageContext = () => {
  return useContext(StorageContext);
};
